export function phoneWorkNumber(phone) {
  return {
    Type: 'Work',
    Number: phone && phone.length ? phone : '',
  };
}
